import { Plus as AddIcon } from "lucide-react";
import { useParams } from "react-router-dom";

import { UsersType } from "api/users/types";
import PageLayout from "components/layouts/PageLayout";
import { hasPermissions } from "components/stores/UserStore";
import UltimateButton from "components/UltimateButton";
import { useModal } from "utils/hooks/useModal";

import UsersTable from "./UsersTable";
import NewUserModal from "./UsersTable/components/NewUserModal";
import { useUsersFilter } from "./UsersTable/useUsersFilter";

const SingleOrganisationPage = () => {
  const { organisationId } = useParams<{ organisationId: string }>();
  const { filters, searchField } = useUsersFilter({
    filter: [
      {
        field: "organisation",
        operator: "is",
        value: organisationId ?? "",
      },
    ],
  });
  const { isOpen, handleClose, handleOpen } = useModal<UsersType>();

  return (
    <>
      <PageLayout
        title="Organisation User Management List"
        subtitle="Users belonging to this organisation."
        search={{
          value: searchField.value,
          onChange: searchField.onChange,
          placeholder: "Search by email",
        }}
        actions={
          hasPermissions("write:users") ? (
            <UltimateButton
              text="Add User"
              Icon={
                AddIcon as React.ComponentType<{
                  size?: number;
                  className?: string;
                  style?: React.CSSProperties;
                }>
              }
              sx={{ py: 1 }}
              onClick={() => handleOpen()}
            />
          ) : undefined
        }
      >
        <UsersTable filters={filters} />
      </PageLayout>
      {hasPermissions("write:users") && (
        <NewUserModal isOpen={isOpen} handleClose={handleClose} />
      )}
    </>
  );
};

export default SingleOrganisationPage;
